var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{staticClass:"empty",attrs:{"description":"404页面找不到了","image":"network","image-size":"180px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }